import { List } from "@mantine/core"
import React
 from "react"
const OrderTerminationConfirm = ({  mainForm  }) =>{ 


    return (
        <List>
                <List.Item>This order will be terminated</List.Item>
                <List.Item>All pending bids will be disabled from consultant wallet</List.Item>
                <List.Item>Commission clawback from provider may applied to consultants.</List.Item>
                <List.Item>Consultants will receive corresponding notification</List.Item>
        </List>
    )

}

export default OrderTerminationConfirm